export class ResetState {
    public static readonly type = '[DataCollection] Reset health and safety state';
}
